import React from 'react';
import Styled from './styled';
import { UserIcon, ClockIcon } from '../index';

export type EventProps = {
    /** Which type of Event Indicator Color (defaults to CUSTOM_BOT) */
    indicator?: 'AGENT' | 'CUSTOMER' | 'CUSTOM_BOT' | 'SUPERVISOR' | 'SYSTEM' | 'DISCONNECTED' | 'IDLE';
    /** Icon to display along with Event Indicator (defaults to user) */
    icon?: 'user' | 'timer';
    /** Text to display along with Icon */
    text: string;
};

/**
 * EventIndicator component
 * 
 * @param props - The properties to configure the EventIndicator components.
 * @returns The rendered component.
 */

export const Event: React.FC<EventProps> = ({
    indicator = 'CUSTOM_BOT',
    icon = 'user',
    text,
}) => {
    return (
        <Styled.EventWrapper>
            <Styled.EventIcon indicator={indicator}>
                {icon === 'timer' && <ClockIcon />}
                {icon === 'user' && <UserIcon />}
            </Styled.EventIcon>
            <Styled.EventText>
                {text}
            </Styled.EventText>
        </Styled.EventWrapper>
    );
};